import React from 'react'
import { Link } from 'react-router-dom'
import { MdLocationOn } from 'react-icons/md'

/*
 * Company details shown in the footer.
 *
 * These MUST match the Business Registration (BR) certificate exactly --
 * Meta Business Verification cross-checks the footer of the website listed
 * under "Company Details" against the BR certificate / business licence.
 */
const COMPANY = {
    legalName: 'Alfred Solutions Private Limited',
    registeredAddress: 'Aspire Coworks #17, 2nd Floor, 7th Main, Indiranagar (Bangalore), Bangalore North, Bangalore- 560038, Karnataka',
}

export default function Footer() {

    const handleLinkClick = () => {
        window.scrollTo(0, 0);  // Scroll to top whenever any link is clicked
    };

  return (
    <div className='mt-12'>
        
        <div className='flex flex-col lg:flex-row bg-[#FF5A5F] px-4 lg:px-12 text-white p-12 justify-center gap-[30px] items-center '>
            <div className='flex-1'>
                <h2 className='text-3xl lg:text-4xl' >
                Join Our Exclusive Platform Now
                </h2>
                <h5 className='text-white mt-7 text-md' style={{lineHeight : "25px"}}>
                Join us for an interactive demo session where you'll get a firsthand experience of our latest product. During the session, we'll walk you through key features, showcase how the product works in real time, and explain its practical applications. This is a great opportunity to ask questions, gain insights, and understand how this solution can benefit you or your business.
                </h5>
            </div>

            <div className='flex-1'>
                <div className='flex justify-center gap-[40px] flex-wrap'>
                    <Link to="/" onClick={()=>handleLinkClick()}>Home</Link>
                    <Link to="/products" onClick={()=>handleLinkClick()}>Products</Link>
                    <Link to="/demo" onClick={()=>handleLinkClick()}>Demo</Link>
                    <Link to="/blogs" onClick={()=>handleLinkClick()}>Blogs</Link>
                    <Link to="/contact" onClick={()=>handleLinkClick()}>Contact</Link>
                </div>
            </div>
        </div>

        {/* Company information -- required for Meta Business Verification */}
        <div className='bg-[#FF5A5F] text-white px-4 lg:px-12 py-10 border border-t-1 border-white/40'>
            <div className='max-w-2xl mx-auto text-center'>
                <h3 className='font-bold text-lg tracking-wide'>
                    {COMPANY.legalName}
                </h3>
                <div className='mt-3 flex gap-2 items-start justify-center'>
                    <MdLocationOn className='mt-1 shrink-0' aria-hidden="true" />
                    <address className='not-italic text-sm' style={{lineHeight : "22px"}}>
                        {COMPANY.registeredAddress}
                    </address>
                </div>
            </div>
        </div>

        <div className='text-center bg-[#FF5A5F] py-5 border border-t-1 border-white'>
            <h2 className='font-bold text-white'>
                © {new Date().getFullYear()} {COMPANY.legalName}. All Rights Reserved.
            </h2>
        </div>
 
    </div>
  )
}
